import * as React from 'react';

interface IPromoCodeTextBoxProps {
    promoErrorMessage: string;
    applying: boolean;
    clearPromoErrorMessage: () => void;
    promoCodeTitle: string;
    onApplyPromoClick: (promoCode: string) => void;
    onCancelPromoClick: () => void;
}

class PromoCodeTextBox extends React.PureComponent<IPromoCodeTextBoxProps, { promoCode: string }>{
    constructor(props) {
        super(props);
        this.state = { promoCode: "" };
    }

    render() {
        {/* TODO: hardcoded strings */}
        const hasError = this.props.promoErrorMessage.length > 0;
        return (
            <div className="promo-code-apply-container">
                <div className="promo-code-apply-standard">

                    <label htmlFor="promoCodeBox">Enter Promo Code</label>
                    <input className="promo-code-apply-input" type="text" maxLength={255} id="promoCodeBox" name="promoCode" value={this.state.promoCode}
                        onChange={(evt) => { this._onPromoCodeInputChange(evt) }}
                        onKeyPress={(e) => {
                            var code = e.keyCode || e.which;

                            if (code === 13 && this.state.promoCode.length > 0) {
                                this.props.onApplyPromoClick(this.state.promoCode);
                            }
                        }}
                        placeholder="I have a promo code"
                        aria-invalid={hasError ? "true" : "false"}
                        aria-describedby={hasError ? "promo-code-error" : null}
                    />
                    <button className="promo-code-apply-btn"
                        disabled={this.state.promoCode.length === 0 || this.props.applying}
                        data-loading-indicator={this.props.applying}
                        onClick={() => { this.props.onApplyPromoClick(this.state.promoCode) }}
                    >
                        Apply<span className="visually-hidden"> {this.props.promoCodeTitle}</span>
                    </button>
                </div>
            </div>
        );
    }

    _onPromoCodeInputChange(evt) {
        this.setState({
            promoCode: (evt.target as any).value
        });

        if (this.props.promoErrorMessage.length > 0) {
            this.props.clearPromoErrorMessage();
        }
    }

    _onCancelPromoCodeClick() {
        this.setState({
            promoCode: ""
        });
        this.props.onCancelPromoClick();
    }
}

export default PromoCodeTextBox;